/**
 * A component displaying the popular products in the home page.
 *
 * Author: Bounlith Sirivong <bounlith.sirivong@ircamamplify.com>
 * Copyright (c) Ircam Amplify 2025
 */

import HomePageIcon from '../HomePageIcon'
import TabContainer from '../TabContainer'
import { Link } from 'react-router-dom'

import { useNavigate } from 'react-router-dom'
import './styles/popular-products.css'

const ICON_SET_DIR = '/icon/set/png_stroke/1x'
const MUSIC_SET_DIR = 'orange'
const VOICE_SET_DIR = 'orange'
const ICON_FORMAT = 'png'

interface PopularItemProps {
  title: string
  description: string
  icon: any
  link: string
}

const PopularItem = (props: PopularItemProps) => {
  const navigate = useNavigate()

  return (
    <div className="popular-item" onClick={() => navigate(props.link)}>
      <HomePageIcon src={props.icon} alt={props.title} background={'#2E2F3C'} />
      <div className="text-side">
        <div className="title">{props.title}</div>
        <div className="description">{props.description}</div>
      </div>
      <img className="go-button" src="/icon/CaretRight.svg" />
    </div>
  )
}

const PopularVoiceModuleList = () => {
  return (
    <div className="popular-module-list">
      <PopularItem
        title="AI Speech Detector"
        description="Verify voice recordings' authenticity"
        icon={`${ICON_SET_DIR}/${VOICE_SET_DIR}/23-Generate.${ICON_FORMAT}`}
        link="/job-creation/ai-speech-detector"
      />
      <PopularItem
        title="Stem Separator"
        description="Split vocal and instrumental"
        icon={`${ICON_SET_DIR}/${VOICE_SET_DIR}/20-Extract.${ICON_FORMAT}`}
        link="/job-creation/stem-separator"
      />
      <PopularItem
        title="Talk Analyzer"
        description="Get speech characteristics"
        icon={`${ICON_SET_DIR}/${VOICE_SET_DIR}/61-Voice.${ICON_FORMAT}`}
        link="/job-creation/talk-analyzer"
      />
    </div>
  )
}

const PopularMusicModuleList = () => {
  return (
    <div className="popular-module-list">
      <PopularItem
        title="Stem Separator"
        description="Separate stems from a mixed track"
        icon={`${ICON_SET_DIR}/${MUSIC_SET_DIR}/54-Stems.${ICON_FORMAT}`}
        link="/job-creation/stem-separator"
      />
      <PopularItem
        title="Music Tagger"
        description="Extract information from music"
        icon={`${ICON_SET_DIR}/${MUSIC_SET_DIR}/37-Metrics.${ICON_FORMAT}`}
        link="/job-creation/music-tagger"
      />
      <PopularItem
        title="AI Re-Editor"
        description="Trim a track to a specific duration"
        icon={`${ICON_SET_DIR}/${MUSIC_SET_DIR}/56-Synch.${ICON_FORMAT}`}
        link="/job-creation/ai-re-editor"
      />
    </div>
  )
}

const ExploreAllComp = () => {
  return (
           <div className="explore-container">
              <Link to="/job-creation" className="explore-link">
                Explore all
              </Link>
            </div>

  )
}

const PopularProducts = () => {
  return (
    <div className="popular-products">
      <TabContainer tabList={['Voice', 'Music']} customComp={<ExploreAllComp />}>
        <PopularVoiceModuleList />
        <PopularMusicModuleList />
      </TabContainer>
    </div>
  )
}

export default PopularProducts
